import React from "react";

import { BaseProps } from "src/types";
import { useContent } from "./hooks";

export const Content = (props: BaseProps) => {
  const { getContentProps } = useContent();
  return <div {...getContentProps()}>{props.children}</div>;
};
